import axios from 'axios';

// internal
import { endpoint, headers } from '@app/utils/service';
import {
  FetchUser,
  FetchUserSelect,
  FetchMyUser,
  UpdateUser,
  FetchUserWithId,
  FetchUserWithEmailName,
  FetchEmailResponse,
  InviteUser,
  UpdateUserInvite,
  UploadUserPicture,
  DeleteUser,
  ProfileFaceIdUploadAction,
  MeAction,
  FetchEndUserAction,
  FetchUserByName,
  GetLinkLine,
} from '@app/typings/services/user';
import { getInviteToken, getProject } from '@app/utils/localStorage';

export const me: MeAction = () => {
  return axios({
    url: endpoint('/users/me'),
    ...headers(),
  });
};
export const fetchEndUser: FetchEndUserAction = (userId) => {
  return axios({
    url: endpoint(`/users/${userId}`),
    ...headers(),
  });
};

export const fetchUser: FetchUser = (data) => {
  const { brief } = data;
  return axios({
    url: endpoint(`/users`),
    method: 'GET',
    params: {
      brief,
    },
    ...headers(),
  });
};

export const genLinkLine: GetLinkLine = (userId) => {
  return axios({
    url: endpoint(`/users/request-web-view`),
    method: 'POST',
    data: {
      userId,
      projectId: getProject(),
    },
    ...headers(),
  });
};

export const fetchZoneSelect: FetchUserSelect = (projectIds) => {
  return axios({
    url: endpoint(`/users`),
    method: 'GET',
    params: {
      brief: true,
      projectIds: projectIds,
    },
    ...headers(),
  });
};

export const fetchUserByName: FetchUserByName = ({ projectId, firstName, lastName }) => {
  return axios({
    url: endpoint(`/users`),
    method: 'GET',
    params: {
      brief: true,
      projectIds: projectId,
      firstName: firstName || undefined,
      lastName: lastName || undefined,
    },
    ...headers(),
  });
};

export const fetchEmailProject: FetchEmailResponse = (projectIds) => {
  return axios({
    url: endpoint(`/users`),
    method: 'GET',
    params: {
      projectIds: projectIds,
      limit: 0,
    },
    ...headers(),
  });
};
export const fetchUserWithEmailName: FetchUserWithEmailName = (
  projectIds,
  email,
  firstName,
  lastName,
) => {
  const params = !!email
    ? {
        brief: true,
        projectIds: projectIds,
        email: email || undefined,
      }
    : {
        brief: true,
        projectIds: projectIds,
        firstName: firstName || undefined,
        lastName: lastName || undefined,
      };
  return axios({
    url: endpoint('/users'),
    method: 'GET',
    params,
    ...headers(),
  });
};

export const fetchMyUser: FetchMyUser = (isInvite) => {
  if (isInvite) {
    return axios({
      url: endpoint('/users/me'),
      method: 'GET',
      ...headers({ Authorization: `Bearer ${getInviteToken()}` }, false),
    });
  } else {
    return axios({
      url: endpoint('/users/me'),
      method: 'GET',
      ...headers(),
    });
  }
};

export const updateUser: UpdateUser = (data, userId) => {
  return axios({
    url: endpoint(`/users/${userId}`),
    method: 'PATCH',
    ...headers(),
    data: {
      firstName: data.firstName,
      phone: data.phoneNumber,
      lastName: data.lastName,
      profileName: data.profileName,
      password: data.password,
    },
  });
};

export const profileFaceId: ProfileFaceIdUploadAction = (id, file) => {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('userId', id);

  return axios({
    url: endpoint(`/projects/${getProject()}/users`),
    method: 'PUT',
    data: formData,
    ...headers(),
  });
};

export const updatePassCodeUser: UpdateUser = (data, userId) => {
  return axios({
    url: endpoint(`/users/${userId}`),
    method: 'PATCH',
    ...headers(),
    data: {
      passcode: {
        code: data.passcode,
      },
    },
  });
};

export const fetchUserWithId: FetchUserWithId = (userId) => {
  return axios({
    url: endpoint(`/users/${userId}`),
    method: 'GET',
    ...headers(),
  });
};

export const inviteUser: InviteUser = (email, isBrand, roleId, groupIds) => {
  return axios({
    url: endpoint(`/users/invite`),
    method: 'POST',
    ...headers(),
    data: {
      email: email,
      isBrand: isBrand,
      roleId,
      groupIds: groupIds || undefined,
    },
  });
};

export const updateUserInvite: UpdateUserInvite = (data, userId) => {
  return axios({
    url: endpoint(`/users/${userId}`),
    method: 'PATCH',
    ...headers({ Authorization: `Bearer ${getInviteToken()}` }, false),
    data: {
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
    },
  });
};

export const uploadUserPicture: UploadUserPicture = (userId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios({
    url: endpoint(`/users/${userId}/upload`),
    method: 'POST',
    data: formData,
    ...headers({ 'Content-Type': 'multipart/form-data' }),
  });
};

export const deleteUser: DeleteUser = (userId) => {
  return axios({
    url: endpoint(`/users/${userId}`),
    method: 'DELETE',
    ...headers(),
  });
};
